import { Box, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Paper, Select, TextField } from '@mui/material';
import { useFieldArray } from 'react-hook-form';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import UTextField2 from '../../utils/UTextField2';
import USelect from '../../utils/USelect';

export default function FastPlaybacksComponent() {
  const { fields, remove, insert, append } = useFieldArray({
    name: 'fastPlaybacks',
  });
  const defaultValue = {
    speed: '',
    bandwidth: '2000',
    framerate: '30',
    storage: '10',
    time: '0',
  };
  return (
    <>
      {fields.map((field, index) => {
        const add = () => {
          insert(index + 1, defaultValue);
        };
        const del = () => {
          remove(index);
        };
        return (
          <Grid key={field.id} item xs={12}>
            <Paper style={{ backgroundColor: '#ffe8e8', padding: '16px 10px' }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {index == 0 && <h1 style={{ fontSize: '14px', margin: 0 }}>Fast playbacks</h1>}
                </Grid>
                <Grid item xs={4}>
                  <USelect fullWidth label="Speed" name={`fastPlaybacks.${index}.speed` as `fastPlaybacks.0.speed`}>
                    <MenuItem value={30}>30x</MenuItem>
                    <MenuItem value={60}>60x</MenuItem>
                    <MenuItem value={120}>120x</MenuItem>
                    <MenuItem value={600}>600x</MenuItem>
                    <MenuItem value={1200}>1200x</MenuItem>
                    <MenuItem value={3333}>3333x</MenuItem>
                  </USelect>
                </Grid>
                <Grid item xs={4}>
                  <USelect
                    fullWidth
                    label="Bandwidth"
                    name={`fastPlaybacks.${index}.bandwidth` as `fastPlaybacks.0.bandwidth`}
                  >
                    <MenuItem value={1000}>1000 kbps</MenuItem>
                    <MenuItem value={1500}>1500 kbps</MenuItem>
                    <MenuItem value={2000}>2000 kbps</MenuItem>
                    <MenuItem value={2500}>2500 kbps</MenuItem>
                    <MenuItem value={3000}>3000 kbps</MenuItem>
                    <MenuItem value={4000}>4000 kbps</MenuItem>
                    <MenuItem value={5000}>5000 kbps</MenuItem>
                  </USelect>
                </Grid>
                <Grid item xs={4}>
                  <USelect
                    fullWidth
                    label="Frame rate"
                    name={`fastPlaybacks.${index}.framerate` as `fastPlaybacks.0.framerate`}
                  >
                    <MenuItem value={15}>15 fps</MenuItem>
                    <MenuItem value={30}>30 fps</MenuItem>
                    <MenuItem value={60}>60 fps</MenuItem>
                  </USelect>
                </Grid>
                <Grid item xs={4}>
                  <UTextField2
                    name={`fastPlaybacks.${index}.storage` as `fastPlaybacks.0.storage`}
                    options={{
                      required: 'value required',
                      min: { value: 0, message: 'should be > 0' },
                      max: { value: 10000, message: 'should be < 10000' },
                      valueAsNumber: true,
                    }}
                    fullWidth
                    label="Storage"
                    endAdornment={<InputAdornment position="end">Gb</InputAdornment>}
                    shrink={true}
                    type="number"
                    defaultValue=""
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <UTextField2
                    name={`fastPlaybacks.${index}.time` as `fastPlaybacks.0.time`}
                    options={{
                      required: 'value required',
                      min: { value: 0, message: 'should be > 0' },
                      max: { value: 365, message: 'should be < 365' },
                      valueAsNumber: true,
                    }}
                    fullWidth
                    label="Storage"
                    endAdornment={<InputAdornment position="end">days</InputAdornment>}
                    shrink={true}
                    type="number"
                    defaultValue=""
                    required
                  />
                </Grid>
                <Grid container item alignItems="center" justifyContent="center" xs={4}>
                  <Box display="flex" flexDirection="column">
                    <AddCircleIcon onClick={add} style={{ cursor: 'pointer' }} />
                    <RemoveCircleIcon onClick={del} style={{ cursor: 'pointer' }} />
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        );
      })}
      {fields.length == 0 && (
        <Grid item xs={12}>
          <Paper style={{ backgroundColor: '#ffe8e8', padding: '16px 10px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <h1 style={{ fontSize: '14px', margin: 0 }}>Fast playbacks</h1>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel>Speed</InputLabel>
                  <Select
                    defaultValue={0}
                    label="Speed"
                    onChange={(evt) => {
                      if (evt.target.value > 0) {
                        const speed = evt.target.value;
                        const storage = 10;
                        const time = 0;
                        const framerate = speed > 30 ? 30 : 15;
                        const bandwidth = 2000;
                        append({ speed, bandwidth, framerate, storage, time });
                        evt.target.value = 0;
                      }
                    }}
                  >
                    <MenuItem value={0}></MenuItem>
                    <MenuItem value={30}>30x</MenuItem>
                    <MenuItem value={60}>60x</MenuItem>
                    <MenuItem value={120}>120x</MenuItem>
                    <MenuItem value={600}>600x</MenuItem>
                    <MenuItem value={1200}>1200x</MenuItem>
                    <MenuItem value={3333}>3333x</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  disabled={true}
                  fullWidth
                  label="Bandwidth"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">kbps</InputAdornment>,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  type="number"
                  defaultValue=""
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  disabled={true}
                  fullWidth
                  label="Frame rate"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">fps</InputAdornment>,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  type="number"
                  defaultValue=""
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  disabled={true}
                  fullWidth
                  label="Storage"
                  type="number"
                  defaultValue=""
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Gb</InputAdornment>,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  disabled={true}
                  fullWidth
                  label="Storage"
                  type="number"
                  defaultValue=""
                  InputProps={{
                    endAdornment: <InputAdornment position="end">days</InputAdornment>,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid container item alignItems="center" justifyContent="center" xs={4}></Grid>
            </Grid>
          </Paper>
        </Grid>
      )}
    </>
  );
}
